import { en, TranslationKeys } from "./en";
import { fr } from "./fr";
import { es } from "./es";

export type { TranslationKeys };

export const translations: Record<string, TranslationKeys> = {
  en,
  fr,
  es,
  default: en,
};

export const getTranslation = (locale: string): TranslationKeys => {
  return translations[locale] || translations.en;
};

